import { AvailableLanguages } from '../../types/i18n';

const formatShortLangPrefix = (langPrefix: string): AvailableLanguages => {
  if (langPrefix.toLowerCase() === 'pt-br' || langPrefix.toLowerCase() === 'sv-se') {
    return langPrefix.toLowerCase().slice(0, 2) as AvailableLanguages;
  }

  return langPrefix as AvailableLanguages;
};

export default formatShortLangPrefix;
